import SvgIcon from '@mui/material/SvgIcon';
import React, { memo } from 'react';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconGermanyComponent = ({ ...rest }) => {
  return (
    <SvgIcon {...rest}>
      <svg
        fill="none"
        height="60"
        viewBox="0 0 80 60"
        width="80"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 8C0 3.58172 3.58172 0 8 0H72C76.4183 0 80 3.58172 80 8V20H0V8Z"
          fill="#000001"
        />
        <rect fill="#FF0000" height="20" width="80" y="20" />
        <path
          d="M0 40H80V52C80 56.4183 76.4183 60 72 60H8C3.58172 60 0 56.4183 0 52V40Z"
          fill="#FFCC00"
        />
      </svg>
    </SvgIcon>
  );
};

IconGermanyComponent.displayName = 'IconGermany';

const IconGermany = memo(IconGermanyComponent);

export default IconGermany;
